export enum ConfigTypeEnum {
    BE = 'BE',
    FE = 'FE',
    NONE = 'NONE'
  }